export default defineNuxtRouteMiddleware(async (to, from) => {
  devConsole.info("🛠️ Access middleware", {
    to: to.fullPath,
    from: from.fullPath,
  });

  const { withResetAuthFlow, awaitUserAndOrganizationLoaded } =
    useOrganizationApi();

  const guards: MiddlewareGuard[] = [
    useSettingsGuard(),
    useSubscriptionGuard(),
    useFacilityWizardGuard(),
    useFacilityImportGuard(),
  ];

  return await withResetAuthFlow(async (authFlow) => {
    for (const guard of guards) {
      if (!guard.guardExitRoute) continue;
      const canExit = await guard.guardExitRoute({
        to,
        from,
      });

      if (!canExit.ok) {
        devConsole.info(`🔒 Leaving route prevented by ${guard.name}`);
        return canExit.result;
      }
    }

    await awaitUserAndOrganizationLoaded();

    for (const guard of guards) {
      if (!guard.guardRouteAccess) continue;
      const canAccess = await guard.guardRouteAccess({
        to,
        from,
        authFlow,
      });

      if (!canAccess.ok) {
        devConsole.info(`🔒 Access denied by ${guard.name}`);
        return canAccess.result;
      }
    }
  });
});
